import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, List, ListItem, ListItemText } from '@mui/material';

import type { Proposal } from 'api/projectVersioning/types';

import { ActiveProposalRowMenu } from './ActiveProposalRowMenu';
import { ProposalListRow } from './ProposalListRow';
import { buildProposalSecondaryText } from './utils/buildProposalSecondaryText';

type ActiveProposalsListProps = {
  proposals: Proposal[];
  menuAnchorEl: HTMLElement | null;
  proposalForMenu: Proposal | null;
  onOpenMenu: (event: React.MouseEvent<HTMLElement>, proposal: Proposal) => void;
  onCloseMenu: () => void;
  navigateToProposal: (targetProposalId: string) => void;
  onDiscardProposal: () => void;
  disabled?: boolean;
  loading?: boolean;
};

export const ActiveProposalsList: React.FC<ActiveProposalsListProps> = ({
  proposals,
  menuAnchorEl,
  proposalForMenu,
  onOpenMenu,
  onCloseMenu,
  navigateToProposal,
  onDiscardProposal,
  disabled,
  loading
}) => (
  <>
    <List>
      {proposals.length > 0 ? (
        proposals.map((proposal) => (
          <ProposalListRow
            key={proposal.id}
            proposal={proposal}
            secondaryText={buildProposalSecondaryText(proposal)}
            variant='active'
            actions={
              <IconButton
                edge='end'
                aria-label='Proposal actions'
                onClick={(e) => onOpenMenu(e, proposal)}
                size='small'
                data-testid={`proposal-actions-button-${proposal.name}`}
              >
                <MoreHorizIcon />
              </IconButton>
            }
          />
        ))
      ) : (
        <ListItem>
          <ListItemText secondary="You don't have any active proposals yet. Start a new one to get things moving." />
        </ListItem>
      )}
    </List>
    <ActiveProposalRowMenu
      anchorEl={menuAnchorEl}
      open={Boolean(menuAnchorEl && proposalForMenu)}
      proposal={proposalForMenu}
      onClose={onCloseMenu}
      navigateToProposal={navigateToProposal}
      onDiscardProposal={onDiscardProposal}
      disabled={disabled}
      loading={loading}
    />
  </>
);
